import { useState } from 'react';
import Reveal from '@/components/feature/Reveal';
import SectionTitle from './SectionTitle';
import { CATEGORIES } from '@/mocks/anime';

export default function Categories() {
  const [active, setActive] = useState(CATEGORIES[0]);

  return (
    <section id="category" className="bg-background-100/70 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionTitle
          eyebrow="分类导览"
          title="主题分类随心选"
          desc="按类型快速找到你的心头好，热血、奇幻、恋爱、治愈一网打尽。点击分类查看代表性作品，找番更高效。"
        />

        <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-4 md:mt-14 md:gap-5">
          {CATEGORIES.map((cat, i) => {
            const isActive = active.name === cat.name;
            return (
              <Reveal key={cat.name} delay={i * 50}>
                <button
                  type="button"
                  onClick={() => setActive(cat)}
                  className={`group flex w-full flex-col items-start rounded-2xl border p-5 text-left transition-all hover:-translate-y-1 ${
                    isActive
                      ? 'border-primary-300 bg-background-50 shadow-[0_10px_30px_-14px_oklch(var(--primary-500)/0.5)]'
                      : 'border-background-200 bg-background-50/70 hover:border-primary-200'
                  }`}
                >
                  <span className={`flex h-11 w-11 items-center justify-center rounded-xl ${cat.color}`}>
                    <i className={`${cat.icon} text-xl`}></i>
                  </span>
                  <h3 className="mt-4 font-heading text-base text-foreground-950">{cat.name}</h3>
                  <p className="mt-1 text-xs text-foreground-500">{cat.desc}</p>
                  <span className="mt-3 flex items-center gap-1 text-xs font-semibold text-primary-600">
                    <i className={`${isActive ? 'ri-checkbox-circle-fill' : 'ri-arrow-right-circle-line'} transition-transform group-hover:translate-x-0.5`}></i>
                    {cat.count} 部作品
                  </span>
                </button>
              </Reveal>
            );
          })}
        </div>

        {/* 选中分类的代表作品 */}
        <Reveal className="mt-8">
          <div className="flex flex-col items-start gap-4 rounded-2xl border border-primary-200 bg-primary-100/40 p-6 md:flex-row md:items-center md:justify-between">
            <div>
              <p className="font-heading text-lg text-primary-700">{active.name} · 代表作</p>
              <p className="mt-1 text-xs text-foreground-600">以下为该分类下的高人气作品，入口清晰、打开即看。</p>
            </div>
            <div className="flex flex-wrap gap-2">
              {active.works.map((w) => (
                <a
                  key={w}
                  href="#hot"
                  className="rounded-full bg-background-50 px-3.5 py-1.5 text-xs font-semibold text-foreground-700 shadow-sm transition-colors hover:bg-primary-500 hover:text-background-50 whitespace-nowrap"
                >
                  {w}
                </a>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}